import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { toggleWorkWindow, visibleWorkWindow, getFieldWorkWindowCancel, getGeoFieldReport } from '../../../actions/geo';
import { Unit } from '../../../helpers/unit';
import { WorkedAcres } from './utils';
import ShapeName from './ShapeName';
// import WorkedStatusModal from './WorkedStatusModal'
import MultipleSelection from './MultipleSelection';
import { HARVESTING_PLAN_TYPE_ID, PLANTING_PLAN_TYPE_ID, PLANTING_WORK_TYPE_ID, WORK_TYPE_LIST } from '../../../constants';
import moment from 'moment';

class ShapePopupTwo extends React.Component {
	constructor() {
		super();
		this.unit = Unit.getInstance();
		this.state = {
			selectedWorkTypeId: null,
			isOpenDropDown: false
		};

		this.handleToggle = this.handleToggle.bind(this);
		this.handleWorkType = this.handleWorkType.bind(this);
		this.onRefresh = this.onRefresh.bind(this);
	}

	componentDidMount() {
		const selectedWorkTypeId = this.props.shape.workTypeId ? this.props.shape.workTypeId : this.props.planTypeId === PLANTING_PLAN_TYPE_ID ? 6 : 2;
		const updatedPlanTypeId = selectedWorkTypeId === PLANTING_WORK_TYPE_ID ? PLANTING_PLAN_TYPE_ID : HARVESTING_PLAN_TYPE_ID;
		const { from, to } = this.props.search.custom;
		const startDate = moment.utc(from).startOf('day').format();
		const endDate = moment.utc(to).endOf('day').format();
		const params = {
			farm_uuid: this.props.shape.farmId,
			geo_region_uuid: this.props.shape.shapeGroupId,
			range_type: updatedPlanTypeId === PLANTING_PLAN_TYPE_ID ? this.props.search.range : "todate",
			plan_type_id: updatedPlanTypeId,
			...(this.props.search.range !== 'todate' ? {
				start_date: startDate ? startDate : null,
				end_date: endDate ? endDate : null
			} : {})
		}
		this.props.actions.getGeoFieldReport(params)
		this.setState({ selectedWorkTypeId }, () => {
			this.props.drawingTool.workWindow.getWorkWindow({ ...this.props.shape, workTypeId: selectedWorkTypeId });
		});
	}

	handleWorkType(workTypeId) {
		this.setState({ selectedWorkTypeId: workTypeId });
		this.props.drawingTool.shapes[this.props.shape.id].workTypeId = workTypeId;
		this.props.drawingTool.workWindow.getWorkWindow({ ...this.props.shape, workTypeId }, true);
	}

	handleToggle(e) {
		const checked = e.target.checked;
		this.props.drawingTool.workWindow.visibleWorkWindow(this.props.shape.id, checked);
		this.props.actions.toggleWorkWindow(this.props.shape.shapeRefId, checked);
	}

	componentWillUnmount() {
		if (this.props.wwInfo && this.props.wwInfo.isRequesting)
			this.props.actions.getFieldWorkWindowCancel(this.props.shape.shapeRefId);
		else {
			this.props.actions.visibleWorkWindow(this.props.shape.shapeRefId, false);
			this.props.drawingTool.workWindow.visibleWorkWindow(this.props.shape.id, false);
		}
	}
	componentDidUpdate(prevProps) {
		if (prevProps.wwInfo && prevProps.wwInfo.workTypeId !== this.props.wwInfo.workTypeId) this.onRefresh(this.props.wwInfo.workTypeId);
	}
	onRefresh(workTypeId) {
		const { from, to } = this.props.search.custom;
		const startDate = moment.utc(from).startOf('day').format();
		const endDate = moment.utc(to).endOf('day').format();
		const updatedPlanTypeId = workTypeId === PLANTING_WORK_TYPE_ID ? PLANTING_PLAN_TYPE_ID : HARVESTING_PLAN_TYPE_ID;
		this.props.actions.getGeoFieldReport({
			farm_uuid: this.props.shape.farmId,
			geo_region_uuid: this.props.shape.shapeGroupId,
			range_type: updatedPlanTypeId === PLANTING_PLAN_TYPE_ID ? this.props.search.range : 'todate',
			plan_type_id: updatedPlanTypeId,
			...(this.props.search.range !== 'todate' ? {
				start_date: startDate ? startDate : null,
				end_date: endDate ? endDate : null
			} : {})
		})
	}

	render() {
		const { shape, drawingTool } = this.props;
		const { settings, fieldReport, fieldReportRequesting, wwInfo, timezone, ...rootProps } = this.props;
		const { isOpenDropDown, selectedWorkTypeId } = this.state;
		const varietyName = drawingTool && drawingTool.shapeGroups && drawingTool.shapeGroups[shape.shapeGroupId] && drawingTool.shapeGroups[shape.shapeGroupId].variety ? drawingTool.shapeGroups[shape.shapeGroupId].variety : null;
		const totalFieldAcres = wwInfo && wwInfo.totalAcres ? wwInfo.totalAcres : 0;

		return <>
			<ShapeName {...rootProps} fieldReport={fieldReport} fieldReportRequesting={fieldReportRequesting} varietyName={varietyName} totalAcres={totalFieldAcres}>
				{({ shapeName, shapeDetail, shapeReport, totalArea, customerName }) => {
					return <div className={`shape-popup shape-popup-two ${isOpenDropDown ? "expend" : ""}`}>
						<div className="shape-popup-body">
							<div className="shape-popup-title d-flex">
								<div>
									<div>{shapeName}</div>
									<div className='customer-name text-muted text-truncate' title={customerName}>{customerName}</div>
								</div>
								<MultipleSelection
									className="avatar-input"
									options={WORK_TYPE_LIST}
									selected={selectedWorkTypeId}
									onSelect={this.handleWorkType}
									onToggle={(isOpen) => {
										if (isOpenDropDown === isOpen) return;
										this.setState({ isOpenDropDown: isOpen })
									}}
									selectedWorkTypeId={this.props.selectedWorkTypeId}
									onRefresh={this.onRefresh}
								/>
							</div>
							<div className="shape-popup-detail">
								<div className='shape-popup__refresh-hldr d-none popup-two'>
									<i
										title="Refresh"
										className="fa fa-refresh btn-refresh"
										aria-hidden="true"
										onClick={this.onRefresh}
									/>
								</div>
								{shapeDetail}
								{shapeReport}
								<WorkedAcres
									shape={shape}
									wwInfo={wwInfo}
									unit={this.unit}
									settings={settings}
									totalArea={totalArea}
									timezone={timezone}
									workTypeId={selectedWorkTypeId}
									fieldReportRequesting={fieldReportRequesting}
									onToggle={this.handleToggle}
								/>
							</div>
						</div>
					</div>
				}
				}
			</ShapeName >
			{/* <WorkedStatusModal shape={shape} /> */}
		</>
	}
}

const mapDispatchToProps = dispatch => ({
	actions: bindActionCreators({
		visibleWorkWindow, toggleWorkWindow, getFieldWorkWindowCancel, getGeoFieldReport
	}, dispatch)
});

const mapStateToProps = (state, ownProps) => ({
	settings: state.user.settings,
	fieldReport: state.geo.geoFieldReport.payload,
	fieldReportRequesting: state.geo.geoFieldReport.isRequesting,
	timezone: state.farm.currentFarm.timezone_identifier,
	wwInfo: state.geo.fieldWorkWindowById.hasOwnProperty(ownProps.shape.shapeRefId) ?
		state.geo.fieldWorkWindowById[ownProps.shape.shapeRefId] : null,
	planTypeId: state.plan.selectedPlanType,
	search: {
		range: state.analyze.searchParams.range,
		custom: state.analyze.searchParams.custom
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(ShapePopupTwo);